const {
  STORYBLOK_TOKENS: STORYBLOK_TOKENS_STG
} = require("../../utils/fdr/storyblok");
const {
  APPTENTIVE_TOKENS: APPTENTIVE_TOKENS_STG
} = require("../../utils/fdr/apptentive");

module.exports = {
  domain: {
    desktop: "stg.racing.fanduel.com",
    mobile: "stg.racing.fanduel.com",
    talentPicks: "stg.racing.fanduel.com/talent-picks/",
    accountWallet: "account.racing.fanduel.com",
    equibase: "equibase-store.fanduel.com"
  },
  service_host: "service.stg.use2.racing.fndlext.net",
  externalDomain: {
    FDTermsConditions: "https://fanduel.com/terms",
    FDPolicy: "https://fanduel.com/privacy",
    FDRLoginBridge: "https://fanduel.com/sso-auth/fdracing",
    FDRSignup:
      "https://www.fanduel.com/join?next=%2Fsso-auth%2Ffdracing%3Fredirect_uri%3D"
  },
  externalServices: {
    fanduel: "https://api.fanduel.com",
    cpp: "https://promos-api.stg.use2.racing.fndlext.net"
  },
  clientId: "a301e728606047a5b6522727d495b3ed",
  brazeId: "e0b90c9d-dfd9-4809-a627-565a5cd7f3b2",
  storyblokToken: STORYBLOK_TOKENS_STG.STAGING,
  storyblokVersion: "draft",
  appTentiveIos: APPTENTIVE_TOKENS_STG.IOS.PRODUCTION,
  appTentiveAndroid: APPTENTIVE_TOKENS_STG.ANDROID.PRODUCTION,
  appTentiveWeb: APPTENTIVE_TOKENS_STG.WEB.PRODUCTION
};
